import React, { useCallback, useEffect, useMemo, useState } from "react";
import VenmoOpenFailedModal from "./VenmoOpenFailedModal";
import { MODAL_ID } from "../constants";

const EVENT_NAME = "as:venmo-fallback";

export default function VenmoFallbackModal() {
  const [pageUrl, setPageUrl] = useState("");
  const [venmoWebUrl, setVenmoWebUrl] = useState("");
  const [copied, setCopied] = useState(false);

  const modalId = MODAL_ID.VENMO_OPEN_FAILED;

  const showVenmoModal = useCallback(() => {
    const el = document.getElementById(modalId);
    if (!el || !window?.bootstrap?.Modal) return;
    try {
      const inst = window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el);
      inst.show();
    } catch {
      // ignore
    }
  }, [modalId]);

  useEffect(() => {
    const handler = (e) => {
      const nextPageUrl = String(e?.detail?.pageUrl || "").trim();
      const nextVenmoWebUrl = String(e?.detail?.venmoWebUrl || "").trim();
      const sourceModalId = String(e?.detail?.sourceModalId || "").trim();
      setPageUrl(nextPageUrl);
      setVenmoWebUrl(nextVenmoWebUrl);

      // Match existing "modal -> modal" UX: close the source modal first, then show the next.
      if (sourceModalId && window?.bootstrap?.Modal) {
        const sourceEl = document.getElementById(sourceModalId);
        if (sourceEl) {
          try {
            const sourceInst =
              window.bootstrap.Modal.getInstance(sourceEl) || new window.bootstrap.Modal(sourceEl);

            const showNext = () => {
              sourceEl.removeEventListener("hidden.bs.modal", showNext);
              showVenmoModal();
            };

            sourceEl.addEventListener("hidden.bs.modal", showNext);
            sourceInst.hide();
            return;
          } catch {
            // fall through
          }
        }
      }

      window.setTimeout(showVenmoModal, 0);
    };
    window.addEventListener(EVENT_NAME, handler);
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, [showVenmoModal]);

  const safePageUrl = useMemo(() => String(pageUrl || "").trim(), [pageUrl]);
  const safeVenmoWebUrl = useMemo(() => String(venmoWebUrl || "").trim(), [venmoWebUrl]);

  const handleCopyLink = useCallback(async () => {
    if (!safePageUrl) return;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(safePageUrl);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        return;
      }
    } catch {
      // ignore
    }
    // Best-effort fallback: prompt
    try {
      window.prompt("Copy link:", safePageUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore
    }
  }, [safePageUrl]);

  return (
    <VenmoOpenFailedModal
      modalId={modalId}
      pageUrl={safePageUrl}
      venmoWebUrl={safeVenmoWebUrl}
      onCopyLink={safePageUrl ? handleCopyLink : null}
      onUseDefaultBrowser={null}
      copied={copied}
    />
  );
}

